export const isProd = process.env.NODE_ENV === "production";
export const isAppEnvironmentProd = process.env.REACT_APP_APP_ENVIRONMENT === "production";
